import _extends from '../../../node_modules/@babel/runtime/helpers/extends.js';
import _defineProperty from '../../../node_modules/@babel/runtime/helpers/defineProperty.js';
import _slicedToArray from '../../../node_modules/@babel/runtime/helpers/slicedToArray.js';
import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import React from 'react';
import 'prop-types';
import { breakpoints } from '../../constants/breakpoints.json.js';
import { useThemeContext } from '../ThemeProvider/ThemeContext.js';
import Button from '../Buttons/Button.js';
import useHover from '../../utils/useHover.js';
import GlyphCancelCircle from '../../svg/GlyphCancelCircle.js';
import { dlsBrightBlue } from '../../styles/colorsDls/dlsBrightBlue.js';
import { dlsGray05 } from '../../styles/colorsDls/dlsGray05.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/* istanbul ignore next */

var isMobile = function isMobile() {
  return window ? window.innerWidth <= parseInt(breakpoints.md, 10) - 1 : false;
};

var TooltipButton = function TooltipButton(_ref) {
  var icon = _ref.icon,
      info = _ref.info,
      alternateIconProps = _ref.alternateIconProps,
      active = _ref.active,
      theme = _ref.theme;
      _ref.handleTooltipToggle;
      var otherProps = _objectWithoutProperties(_ref, ["icon", "info", "alternateIconProps", "active", "theme", "handleTooltipToggle"]);

  var themeTokens = useThemeContext();

  var _useHover = useHover(otherProps),
      _useHover2 = _slicedToArray(_useHover, 2),
      isHovering = _useHover2[0],
      hoverHandlerProps = _useHover2[1];

  var size = info ? 'lg' : 'md';
  var activeIconButton = themeTokens.primaryColor || dlsBrightBlue.fill;
  var iconToRender = /*#__PURE__*/React.cloneElement(icon, {
    size: icon.props.size || size,
    theme: _objectSpread({
      fill: info && !(isHovering && !isMobile()) ? dlsGray05.fill : activeIconButton,
      lineHeight: 0
    }, icon.props.theme)
  });

  var glyphProps = _objectSpread(_objectSpread({
    size: alternateIconProps.size || 'lg'
  }, alternateIconProps), {}, {
    theme: _objectSpread({
      fill: activeIconButton,
      lineHeight: 0
    }, alternateIconProps.theme)
  });

  var buttonStyleObject = _objectSpread(_objectSpread({}, info ? {
    lineHeight: 0
  } : {}), {}, {
    '&:hover, &:focus': {
      background: 'none'
    }
  }, theme);

  return /*#__PURE__*/React.createElement(Button, _extends({
    theme: buttonStyleObject
  }, hoverHandlerProps, otherProps), info && active ? /*#__PURE__*/React.createElement(GlyphCancelCircle, glyphProps) : iconToRender);
};

TooltipButton.defaultProps = {
  active: undefined,
  info: false,
  alternateIconProps: {},
  handleTooltipToggle: undefined,
  theme: undefined
};

export default TooltipButton;
